// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_78mm_16mm_3_labels_23mm_13mm_layout__2IwGt"};